import '@fortawesome/fontawesome-free/js/all';
import '@hotwired/turbo-rails';
import * as bootstrap from 'bootstrap';
import '../controllers';
import '../themes/appstack4/src/js/app.js';

console.log('Vite ⚡️ Rails');
